import styled from 'styled-components';
import colors from '../../../assets/colors';

export const Content = styled.div`
  max-width: 400px;
  padding: 30px;

  h2 {
    color: ${colors.primary};
    margin: 0 0 10px;
  }

  p {
    font-size: 0.9rem;
    margin: 0 0 25px;
  }
`;

export const Label = styled.div`
  display: flex;
  margin-bottom: 15px;
  background-color: ${colors.white};
  box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  border-radius: 10px;
  border: ${(props) => {
    if (props.error) return `1px solid ${colors.red}`;
    if (props.onFocusInput) return `1px solid ${colors.primary}`;
    return `1px solid ${colors.white}`;
  }};

  .fa {
    margin: 14px 2px 14px 15px;
    color: ${(props) => {
    if (props.error) return `${colors.red}`;
    if (props.onFocusInput) return `${colors.primary}`;
    return `${colors.light}`;
  }};
  }
`;

export const Form = styled.form` 
  display: flex;
  flex-direction: column;
`;

export const Input = styled.input`
  width: 100%;
  background-color: transparent;
  border: none;
  padding: 12px;
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
`;

export const Button = styled.button`
  cursor: pointer;
  margin-top: 15px;
  padding: 15px 0 14px;
  background: ${colors.primary};
  background: linear-gradient(180deg, rgba(55,205,63,1) 0%, rgba(41,157,44,1) 100%);
  border: none;
  border-radius: 100px;
  text-transform: uppercase;
  font-size: 0.9rem;
  font-weight: 600;
  color: ${colors.white};
  font-family: 'Open Sans', sans-serif;
  outline: none;
  
  :hover { opacity: .9 }
`;
